<template>
  <div class="class-1">
    <!-- Header -->
    <AppHeader title="Languages Management" />

    <!-- Action Buttons -->
    <div class="action-buttons-container">
      <button class="add-language-btn" @click="navigateToAddLanguage">Add New Language</button>
    </div>

    <!-- Table Structure -->
    <table id="languageTable">
      <thead>
        <tr>
          <th>Name</th>
          <th>Sequence</th>
          <th>Created At</th>
          <th>Status</th>
          <th>sequence</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(language, index) in languages" :key="index">
          <td>{{ language.fullName }}</td>
          <!-- <td>{{ language.shortName }}</td> -->
          <td>{{ language.sequence }}</td>
          <td>{{ formatDisplayDate(language.created_at) }}</td>
          <td>{{ language.isSuspend ? 'Inactive' : 'Active' }}</td>
          <td class="action-buttons">
            <button data-tooltip="Edit" @click="handleEdit(language)">
              <img src="@/assets/edit_icon.png" alt="Edit">
            </button>
            <button data-tooltip="Delete" @click="confirmDelete(language)">
              <img src="@/assets/delete_icon.png" alt="Delete">
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      languages: [],
      currentDate: "",
      currentTime: "",
    };
  },
  mounted() {
    this.updateDateTime();
    setInterval(this.updateDateTime, 1000);
    this.fetchLanguages();
  },
  methods: {
    formatDisplayDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    updateDateTime() {
      const now = new Date();
      this.currentDate = now.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      this.currentTime = now.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    async fetchLanguages() {
      try {
        this.$root.isLoading = true;
        const token = localStorage.getItem('authToken');
        
        const response = await fetch(`${this.$BASE_API_URL}/api/languages`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        this.languages = data.data;
      } catch (error) {
        console.error('Error fetching languages:', error);
        this.$toast.error('Failed to fetch languages');
      } finally {
        this.$root.isLoading = false;
      }
    },
    async confirmDelete(language) {
      if (!this.$hasPermission('delete languages')) {
        this.$toast.error('Not Permitted');
        return;
      }
      
      if (confirm(`Are you sure you want to delete ${language.fullName}?`)) {
        try {
          this.$root.isLoading = true;
          const token = localStorage.getItem('authToken');
          
          const response = await fetch(`${this.$BASE_API_URL}/api/languages/${language.id}`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });

          if (!response.ok) {
            throw new Error('Failed to delete language');
          }

          this.$toast.success('Language deleted successfully');
          this.fetchLanguages();
        } catch (error) {
          console.error('Error deleting language:', error);
          this.$toast.error('Failed to delete language');
        } finally {
          this.$root.isLoading = true;
        }
      }
    },
    navigateToAddLanguage() {
      if (this.$hasPermission('create languages')) {
        this.$router.push({ name: "AddLanguageComponent" });
      } else {
        this.$toast.error('Not Permitted');
      }
    },
    handleEdit(language) {
      if (this.$hasPermission('edit languages')) {
        this.$router.push({ 
          name: "EditLanguageComponent", 
          params: { id: language.id } 
        });
      } else {
        this.$toast.error('Not Permitted');
      }
    },
  },
};
</script>

<style scoped>
.action-buttons-container {
  margin-right: .5rem;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 10px;
  margin-top: 0.5rem;
}

.add-language-btn {
  padding: 10px;
  background-color: #4caf50;
  border: none;
  cursor: pointer;
  width: max-content;
  border-radius: 5px;
  margin-right: 1rem;
}

.action-buttons button {
  background: none;
  border: none;
  cursor: pointer;
  margin: 0 5px;
  position: relative;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.action-buttons button:hover {
  transform: scale(1.2);
  opacity: 0.8;
}

.action-buttons button:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
}

.action-buttons button img {
  width: 20px;
  height: 20px;
}

/* Icon Colors */
.action-buttons button[data-tooltip="Edit"] img {
  filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(90deg);
}

.action-buttons button[data-tooltip="Delete"] img {
  filter: invert(20%) sepia(100%) saturate(3000%) hue-rotate(350deg);
}
</style>